// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICarrierIdPropertyDto } from './ICarrierIdPropertyDto';
import {
    ICarrierIdPropertyDtoFromJSON,
    ICarrierIdPropertyDtoFromJSONTyped,
    ICarrierIdPropertyDtoToJSON,
    ICarrierIdPropertyDtoToJSONTyped,
} from './ICarrierIdPropertyDto';
import type { INamePropertyDto } from './INamePropertyDto';
import {
    INamePropertyDtoFromJSON,
    INamePropertyDtoFromJSONTyped,
    INamePropertyDtoToJSON,
    INamePropertyDtoToJSONTyped,
} from './INamePropertyDto';
import type { IDeductiblesByServiceTypePropertyDto } from './IDeductiblesByServiceTypePropertyDto';
import {
    IDeductiblesByServiceTypePropertyDtoFromJSON,
    IDeductiblesByServiceTypePropertyDtoFromJSONTyped,
    IDeductiblesByServiceTypePropertyDtoToJSON,
    IDeductiblesByServiceTypePropertyDtoToJSONTyped,
} from './IDeductiblesByServiceTypePropertyDto';
import type { IHealthPlanTypePropertyDto } from './IHealthPlanTypePropertyDto';
import {
    IHealthPlanTypePropertyDtoFromJSON,
    IHealthPlanTypePropertyDtoFromJSONTyped,
    IHealthPlanTypePropertyDtoToJSON,
    IHealthPlanTypePropertyDtoToJSONTyped,
} from './IHealthPlanTypePropertyDto';
import type { IPlanCategorySpendLimitDto } from './IPlanCategorySpendLimitDto';
import {
    IPlanCategorySpendLimitDtoFromJSON,
    IPlanCategorySpendLimitDtoFromJSONTyped,
    IPlanCategorySpendLimitDtoToJSON,
    IPlanCategorySpendLimitDtoToJSONTyped,
} from './IPlanCategorySpendLimitDto';
import type { IHealthPlanEnrollmentMatrixCreateDto } from './IHealthPlanEnrollmentMatrixCreateDto';
import {
    IHealthPlanEnrollmentMatrixCreateDtoFromJSON,
    IHealthPlanEnrollmentMatrixCreateDtoFromJSONTyped,
    IHealthPlanEnrollmentMatrixCreateDtoToJSON,
    IHealthPlanEnrollmentMatrixCreateDtoToJSONTyped,
} from './IHealthPlanEnrollmentMatrixCreateDto';
import type { IHealthPlanDeductibleConfigDto } from './IHealthPlanDeductibleConfigDto';
import {
    IHealthPlanDeductibleConfigDtoFromJSON,
    IHealthPlanDeductibleConfigDtoFromJSONTyped,
    IHealthPlanDeductibleConfigDtoToJSON,
    IHealthPlanDeductibleConfigDtoToJSONTyped,
} from './IHealthPlanDeductibleConfigDto';
import type { IIsAutoEnrollmentPropertyDto } from './IIsAutoEnrollmentPropertyDto';
import {
    IIsAutoEnrollmentPropertyDtoFromJSON,
    IIsAutoEnrollmentPropertyDtoFromJSONTyped,
    IIsAutoEnrollmentPropertyDtoToJSON,
    IIsAutoEnrollmentPropertyDtoToJSONTyped,
} from './IIsAutoEnrollmentPropertyDto';

/**
 * 
 * @export
 * @interface IHealthPlanCreateDto
 */
export interface IHealthPlanCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanCreateDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanCreateDto
     */
    parent_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanCreateDto
     */
    is_plan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanCreateDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanCreateDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanCreateDto
     */
    plan_code?: string;
    /**
     * 
     * @type {INamePropertyDto}
     * @memberof IHealthPlanCreateDto
     */
    name?: INamePropertyDto;
    /**
     * 
     * @type {IHealthPlanTypePropertyDto}
     * @memberof IHealthPlanCreateDto
     */
    health_plan_types?: IHealthPlanTypePropertyDto;
    /**
     * 
     * @type {IDeductiblesByServiceTypePropertyDto}
     * @memberof IHealthPlanCreateDto
     */
    deductibles_by_service_type?: IDeductiblesByServiceTypePropertyDto;
    /**
     * 
     * @type {ICarrierIdPropertyDto}
     * @memberof IHealthPlanCreateDto
     */
    carrier_id?: ICarrierIdPropertyDto;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanCreateDto
     */
    plan_status?: IHealthPlanCreateDtoPlanStatusEnum;
    /**
     * 
     * @type {IIsAutoEnrollmentPropertyDto}
     * @memberof IHealthPlanCreateDto
     */
    is_auto_enrollment?: IIsAutoEnrollmentPropertyDto;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanCreateDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {Set<IHealthPlanDeductibleConfigDto>}
     * @memberof IHealthPlanCreateDto
     */
    health_plan_deductible_configs?: Set<IHealthPlanDeductibleConfigDto>;
    /**
     * 
     * @type {IHealthPlanEnrollmentMatrixCreateDto}
     * @memberof IHealthPlanCreateDto
     */
    enrollment_matrix?: IHealthPlanEnrollmentMatrixCreateDto;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanCreateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanCreateDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanCreateDto
     */
    per_person_spend_limit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanCreateDto
     */
    per_category_spend_limit?: boolean;
    /**
     * 
     * @type {Array<IPlanCategorySpendLimitDto>}
     * @memberof IHealthPlanCreateDto
     */
    category_spend_limits?: Array<IPlanCategorySpendLimitDto>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IHealthPlanCreateDto
     */
    plans?: Set<number>;
}

/**
* @export
* @enum {string}
*/
export enum IHealthPlanCreateDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE'
}


/**
 * Check if a given object implements the IHealthPlanCreateDto interface.
 */
export function instanceOfIHealthPlanCreateDto(value: object): value is IHealthPlanCreateDto {
    return true;
}

export function IHealthPlanCreateDtoFromJSON(json: any): IHealthPlanCreateDto {
    return IHealthPlanCreateDtoFromJSONTyped(json, false);
}

export function IHealthPlanCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'is_plan': json['is_plan'] == null ? undefined : json['is_plan'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'name': json['name'] == null ? undefined : INamePropertyDtoFromJSON(json['name']),
        'health_plan_types': json['health_plan_types'] == null ? undefined : IHealthPlanTypePropertyDtoFromJSON(json['health_plan_types']),
        'deductibles_by_service_type': json['deductibles_by_service_type'] == null ? undefined : IDeductiblesByServiceTypePropertyDtoFromJSON(json['deductibles_by_service_type']),
        'carrier_id': json['carrier_id'] == null ? undefined : ICarrierIdPropertyDtoFromJSON(json['carrier_id']),
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : IIsAutoEnrollmentPropertyDtoFromJSON(json['is_auto_enrollment']),
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'health_plan_deductible_configs': json['health_plan_deductible_configs'] == null ? undefined : (new Set((json['health_plan_deductible_configs'] as Array<any>).map(IHealthPlanDeductibleConfigDtoFromJSON))),
        'enrollment_matrix': json['enrollment_matrix'] == null ? undefined : IHealthPlanEnrollmentMatrixCreateDtoFromJSON(json['enrollment_matrix']),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : json['per_person_spend_limit'],
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : json['per_category_spend_limit'],
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoFromJSON)),
        'plans': json['plans'] == null ? undefined : new Set(json['plans']),
    };
}

export function IHealthPlanCreateDtoToJSON(json: any): IHealthPlanCreateDto {
    return IHealthPlanCreateDtoToJSONTyped(json, false);
}

export function IHealthPlanCreateDtoToJSONTyped(value?: IHealthPlanCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'is_plan': value['is_plan'],
        'summary': value['summary'],
        'notes': value['notes'],
        'plan_code': value['plan_code'],
        'name': INamePropertyDtoToJSON(value['name']),
        'health_plan_types': IHealthPlanTypePropertyDtoToJSON(value['health_plan_types']),
        'deductibles_by_service_type': IDeductiblesByServiceTypePropertyDtoToJSON(value['deductibles_by_service_type']),
        'carrier_id': ICarrierIdPropertyDtoToJSON(value['carrier_id']),
        'plan_status': value['plan_status'],
        'is_auto_enrollment': IIsAutoEnrollmentPropertyDtoToJSON(value['is_auto_enrollment']),
        'plan_year_id': value['plan_year_id'],
        'health_plan_deductible_configs': value['health_plan_deductible_configs'] == null ? undefined : (Array.from(value['health_plan_deductible_configs'] as Set<any>).map(IHealthPlanDeductibleConfigDtoToJSON)),
        'enrollment_matrix': IHealthPlanEnrollmentMatrixCreateDtoToJSON(value['enrollment_matrix']),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'per_person_spend_limit': value['per_person_spend_limit'],
        'per_category_spend_limit': value['per_category_spend_limit'],
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoToJSON)),
        'plans': value['plans'] == null ? undefined : Array.from(value['plans'] as Set<any>),
    };
}

